<template>
  <v-container fluid>
    <v-container>
      <h1 class="text-h3">
        {{ schedule ? schedule.name : $t("scheduleNew") }}
      </h1>
    </v-container>
    <v-container>
      <v-card tile>
        <v-tabs>
          <v-tab>{{ $t("scheduleInfo") }}</v-tab>
          <v-tab v-if="schedule">{{ $t("scheduleSchedule") }}</v-tab>
          <v-tab-item flat>
            <schedule-info :currentSchedule="currentSchedule"></schedule-info>
          </v-tab-item>
          <v-tab-item flat v-if="schedule">
            <schedule-items />
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import ScheduleItems from "@/components/ScheduleItems.vue";
import ScheduleInfo from "@/components/ScheduleInfo.vue";
import { mapGetters } from "vuex";
import store from "../store";

export default {
  name: "Schedule",

  beforeRouteEnter: async (to, from, next) => {
    if (to.params.schedule_id) {
      await store.dispatch("loadSchedule", to.params.schedule_id);
      next();
    } else if (to.params.group_id) {
      next();
    } else {
      next("locations");
    }
  },

  beforeRouteLeave: async (to, from, next) => {
    // refactoring
    store.commit("loadSchedule", null);
    next();
  },

  data() {
    return {
      currentSchedule: {
        name: "",
        items: [],
        breaks: [],
        playground_group: null,
        disabled: true,
      },
    };
  },

  computed: {
    ...mapGetters(["schedule"]),
  },

  components: {
    ScheduleInfo,
    ScheduleItems,
  },

  mounted() {
    if (this.schedule) {
      this.currentSchedule = this.schedule;
    } else {
      this.currentSchedule.playground_group = this.$route.params.group_id;
    }
  },
};
</script>
